<div class="row">
  <div class="col">
    <fx-page-header [title]="'Campaigns'"></fx-page-header>
  </div>
</div>

<div class="layout bg-dark-lighter">
  <form [formGroup]="searchForm" class="controller mb-4" (ngSubmit)="onSearch()">
    <div class="row">
      <div class="col-12 col-lg-10">
        <mat-form-field class="field-control" appearance="outline">
          <mat-label>Campaign Name</mat-label>
          <input type="text" matInput formControlName="campaign_name" style="caret-color: #fff;">
        </mat-form-field>
        <br>
        <p-calendar
          formControlName="create_time"
          required
          placeholder="Created date"
          [dateFormat]="'dd/mm/yy'"
          [timeOnly]="false"
          [showIcon]="true"
          [showSeconds]="false"
          [showTime]="true"
          inputStyleClass="form-control"
          class="schedule_time_picker"
        ></p-calendar>
        <br>
        <div class="mt-4">
          <p-calendar
            formControlName="send_time"
            required
            placeholder="Send date"
            [dateFormat]="'dd/mm/yy'"
            [timeOnly]="false"
            [showIcon]="true"
            [showSeconds]="false"
            [showTime]="true"
            inputStyleClass="form-control"
            class="schedule_time_picker"
          ></p-calendar>
        </div>
      </div>
      <div class="col-12 col-lg-2">
        <div class="d-flex flex-column justify-content-end h-100 align-items-end">
          <div class="d-flex">
            <!--<button
              style="width: fit-content"
              mat-button
              class="btn bg-common"
              type="button"
              (click)="resetSearch()"
            >Reset
            </button>-->
            <button
              style="width: fit-content"
              mat-button
              class="btn bg-common ms-3"
              type="submit"
            >Search
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
  <div class="table-responsive">
    <div class="table-responsive">
      <table class="rox-table table-bordered bg-dark">
        <thead>
          <tr class="ptb-head">
            <th class="text-center">ID</th>
            <th class="text-center">Campaign name</th>
            <th class="text-center">Create date</th>
            <th class="text-center">Send date</th>
            <th class="text-center">Total receivers</th>
            <th class="text-center">Sent</th>
            <th class="text-center">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let dt2 of campaignList | paginate: {
                id: 'cpList',
                itemsPerPage: cpListPageInfo.pageSize,
                currentPage: cpListPageInfo.pageIndex,
                totalItems: cpListPageInfo.totalRecord
              };">
            <td class="text-center">{{ dt2.id }}</td>
            <td
              *ngIf="dt2?.name?.length > 70; else short"
              class="text-left text-primary ellipsis-text"
              role="button"
              (click)="openDetail(dt2)"
              [matTooltip]="dt2.name"
              matTooltipClass="tb-detail"
            >{{ dt2.name }}</td>
            <ng-template #short>
              <td
                class="text-left text-primary"
                role="button"
                (click)="openDetail(dt2)"
              >{{ dt2.name }}</td>
            </ng-template>
            <td class="text-center">{{ dt2.create_time | date: 'dd-MM-YYY HH:mm' }}</td>
            <td class="text-center">{{ dt2.send_time | date: 'dd-MM-YYY HH:mm' }} </td>
            <td class="text-center">{{ dt2.total }}</td>
            <td class="text-center">{{ dt2.sent }}</td>
            <td class="text-center" [ngStyle]="{color: statusColors[dt2.status]}">{{ dt2.status || 0 }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="mt-3">
      <pagination-controls
        id="cpList"
        (pageChange)="onPage($event)"
        [autoHide]="true"
        [responsive]="true"
        previousLabel="Prev"
        nextLabel="Next"
      ></pagination-controls>
    </div>
  </div>
</div>

<ng-template #confirmDialog>
  <div style="max-width: 450px; width: 100%">The campaign
    <ng-container *ngIf="currentCampaign.status.toLowerCase() === 'scheduled'">has not yet started.</ng-container>
    <ng-container *ngIf="currentCampaign.status.toLowerCase() === 'in progress'">is in progress. Once cancelled, system will stop sending emails. Sent emails are not able to be recalled.</ng-container>
    Are you sure you want to cancel the campaign?</div>
  <div class="d-flex justify-content-end mt-2">
    <button mat-stroked-button [cdkTrapFocus]="true" [mat-dialog-close]="true" class="me-3">No</button>
    <button mat-stroked-button (click)="cancel()" [disabled]="onRequesting">Yes</button>
  </div>
</ng-template>

<div class="page-detail" *ngIf="showDetailDialog">
  <div class="dialog-box pt-3 px-3">
    <div class="py-3 ps-3">
      <div class="scrollable" style="margin-right: 0">
        <div class="row mb-3">
          <div class="col-12 col-lg-4">Campaign name</div>
          <div class="col-12 col-lg-8">{{currentCampaign.name}}</div>
        </div>
        <div class="row mb-3">
          <div class="col-12 col-lg-4">Status</div>
          <div class="col-12 col-lg-8" [ngStyle]="{color: statusColors[currentCampaign.status]}">{{currentCampaign.status}}</div>
        </div>
        <div class="row mb-3">
          <div class="col-12 col-lg-4">From</div>
          <div class="col-12 col-lg-8">
            <span class="text-capitalize">{{mainTypes[currentCampaign.content.type_mail]}}</span>
            &nbsp;─&nbsp;
            {{currentCampaign.content.type_mail}}@cryptograph.finance
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-12 col-lg-4">To</div>
          <div class="col-12 col-lg-8">
            <ng-container  *ngIf="currentCampaign.content.type === 'ib'; else condition">
              {{option[currentCampaign.content.option]}}
            </ng-container>
            <ng-template #condition>
              {{currentCampaign.content.accounts.active_ib ? 'IBs' : 'Traders'}}
            </ng-template>
          </div>
        </div>
        <div class="row mb-3" *ngIf="currentCampaign.content.type === 'ib'; else conTo">
          <div class="col-12 col-lg-4"></div>
          <div class="col-12 col-lg-8">
            <div>IBs:</div>
            <div class="text-inner">
              <ng-container *ngFor="let m of currentCampaign.content.emails; last as l">
                {{m}} <ng-container *ngIf="!l">, &nbsp;</ng-container>
              </ng-container>
            </div>
          </div>
        </div>
        <ng-template #conTo>
          <div class="row mb-3">
            <div class="col-12 col-lg-4">In</div>
            <div class="col-12 col-lg-8">{{countryType[currentCampaign.content.country]}}</div>
          </div>
        </ng-template>
        <div class="row mb-3" *ngIf="currentCampaign.content?.accounts?.without_deposit">
          <div class="col-12 col-lg-4">Who</div>
          <div class="col-12 col-lg-8">Never Deposited</div>
        </div>
        <div class="row mb-3">
          <div class="col-12 col-lg-4">Subject</div>
          <div class="col-12 col-lg-8">{{currentCampaign.content.subject}}</div>
        </div>
        <div class="row mb-3">
          <div class="col-12 col-lg-4">Content</div>
          <div class="col-12 col-lg-8">
            <div class="text-inner with-image-content-html" [innerHTML]="currentCampaign.content.text"></div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-12 col-lg-4">Created date</div>
          <div class="col-12 col-lg-8">{{currentCampaign.create_time | date: 'dd-MM-yyyy HH:mm'}}</div>
        </div>
        <div class="row mb-3">
          <div class="col-12 col-lg-4">Send date</div>
          <div class="col-12 col-lg-8">{{currentCampaign.send_time | date: 'dd-MM-yyyy HH:mm'}}</div>
        </div>
        <div class="row mb-3" *ngIf="currentCampaign.cancel_time">
          <div class="col-12 col-lg-4">Cancelled date</div>
          <div class="col-12 col-lg-8">{{currentCampaign?.cancel_time | date: 'dd-MM-yyyy HH:mm'}}</div>
        </div>
        <div class="row mb-3">
          <div class="col-12 col-lg-4">Total receivers</div>
          <div class="col-12 col-lg-8">{{currentCampaign.total}}</div>
        </div>
        <div class="row mb-3">
          <div class="col-12 col-lg-4">Sent</div>
          <div class="col-12 col-lg-8">{{currentCampaign.sent}}</div>
        </div>
        <div class="table-responsive">
          <table class="rox-table table-bordered bg-dark">
            <thead>
              <tr>
                <th class="text-center" style="width: 80px">NO</th>
                <th class="text-center">Receivers</th>
                <th class="text-center">Email Sent Time</th>
                <th class="text-center">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let dt of (campaignDetailList?.data?.mails || []) | paginate: {
                id: 'mailsList',
                itemsPerPage: pageInfo.pageSize,
                currentPage: pageInfo.pageIndex,
                totalItems: pageInfo.totalRecord
              }">
                <td class="text-center">{{dt.id}}</td>
                <td>{{dt.email}}</td>
                <td class="text-center">{{dt.sent_time | date: 'dd-MM-yyyy HH:mm'}}</td>
                <td class="text-center">{{dt.status}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="mt-3">
          <pagination-controls
            id="mailsList"
            (pageChange)="onPageOfMail($event)"
            [autoHide]="true"
            [responsive]="true"
            previousLabel="Prev"
            nextLabel="Next"
          ></pagination-controls>
        </div>
      </div>
      <div class="dialog-footer d-flex justify-content-end mt-3">
        <button mat-stroked-button [cdkTrapFocus]="true" (click)="showDetailDialog = false">Back</button>
        <button *ngIf="!(['done', 'cancelled'].includes(currentCampaign.status.toLowerCase()))" class="ms-3" mat-stroked-button color="warn" (click)="onCancelClicked(currentCampaign.id)">Cancel</button>
      </div>
    </div>
  </div>
</div>
